module.exports = ".code-cubes {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 8px;\n  direction: ltr; }\n\n.cube {\n  width: 44px;\n  height: 52px;\n  text-align: center;\n  font-size: 1.5rem;\n  border: 1px solid #ccc;\n  border-radius: 8px; }\n\n.cube:focus {\n    outline: 2px solid #4a90d9; }\n\n.cube:disabled {\n    opacity: 0.5;\n    cursor: not-allowed; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/code-cubes/code-cubes.component.scss
// module id = ./src/app/common/code-cubes/code-cubes.component.scss
// module chunks = main